import React, { FC, useRef } from "react";
import type { HomeZeroInProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Image } from "../image";
import { useInView } from "@/hooks/reveal-in-view";
import SplitTextAnimation from "../split-text-animation";

export const HomeZeroIn: FC<HomeZeroInProps> = ({
  title,
  content,
  background,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="homeZeroIn">
      <div className="homeZeroIn--inner">
        <div className="wrapper wrapper_lg">
          <div className="homeZeroIn--top">
            <SplitTextAnimation
              htmlElement={<h2 className="homeZeroIn--title">{title}</h2>}
              isInView={isInView}
            />
            {background.file?.url && (
              <Image
                className="homeZeroIn--bg"
                src={background as any}
                alt={background.title}
                options={{
                  sizes: {
                    exec: [
                      {
                        width: 1560,
                        height: 895,
                      },
                    ],
                  },
                }}
                animateInView
              />
            )}
          </div>
          <div
            className="homeZeroIn--content"
            ref={ref}
            style={{
              transform: isInView ? "none" : `translateY(20px)`,
              opacity: isInView ? 1 : 0,
              transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
            }}
          >
            <ContentManager content={content} />
          </div>
        </div>
      </div>
    </section>
  );
};
